"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LCFile = void 0;
class LCFile {
    constructor(_object) {
        this._object = _object;
        this._isLCObject = true;
    }
    get app() {
        return this._object.app;
    }
    get className() {
        return '_File';
    }
    get id() {
        return this._object.id;
    }
    get data() {
        return this._object.data;
    }
    get name() {
        return this.data.name;
    }
    get url() {
        return this.data.url;
    }
    get size() {
        var _a;
        return (_a = this.data.metaData) === null || _a === void 0 ? void 0 : _a.size;
    }
    get mime() {
        return this.data.mime_type;
    }
    static fromJSON(app, data) {
        return new LCFile(app.database().decodeObject(data, '_File'));
    }
    thumbnailURL(width, height, quality = 100, scaleToFit = true, format = 'png') {
        const mode = scaleToFit ? 2 : 1;
        return this.url + `?imageView/${mode}/w/${width}/h/${height}/q/${quality}/format/${format}`;
    }
    delete(options) {
        return this.app.database().class(this.className).object(this.id).delete(options);
    }
    toJSON() {
        return this._object.toJSON();
    }
    _LC_encode(options) {
        const encoded = this._object._LC_encode(options);
        if (encoded.__type === 'Object') {
            encoded.__type = 'File';
        }
        return encoded;
    }
}
exports.LCFile = LCFile;
